import { useEffect, useState } from "react";
import { useController } from "react-hook-form";
import { useContent } from "contexts/contentContext/contentContext.js";

export const useCustomController = ({
  control,
  errors,
  setError,
  item,
  defaultValuesObj = {},
  clearErrors,
  cutomValidation,
}) => {
  const [hasError, setHasError] = useState();
  const { getTextByKey } = useContent();

  const setErrorMessage = (message) => {
    if (!message) {
      clearErrors(item.fieldKey);
    } else {
      setError(item.fieldKey, { message });
    }
  };

  const { field } = useController({
    name: item.fieldKey,
    control,
    ...(defaultValuesObj[item.fieldKey] && {
      defaultValue: defaultValuesObj[item.fieldKey],
    }),
    rules:
      item.validation && !cutomValidation?.checkDisableValidation()
        ? {
            required: item.validation.required,
            validate: item.validation.validate || null,
            pattern: item.validation.reg
              ? {
                  value: item.validation.reg,
                  message: getTextByKey(item.validation.invalidMessage),
                }
              : {},
            maxLength:
              item.validation.maxLength ||
              (item.type === "password" ? 24 : 100),
          }
        : {
            maxLength:
              item.validation?.maxLength ||
              (item.type === "password" ? 24 : 100),
          },
  });

  useEffect(() => {
    setHasError(!!errors[item.fieldKey]);
  }, [errors[item.fieldKey]]);

  return { fieldControls: field, hasError, setErrorMessage, clearErrors };
};
